module.exports = __webpack_public_path__ + "img/disinfectionTunnels.a14e4e08.png";